module.exports = __webpack_public_path__ + "static/img/yj2.bdccd20e.png";